import styled from 'styled-components'

export const ContactWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 100vh;
  padding-top: 13rem;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    height: auto;
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: 570px;
  padding: 0 3rem 3rem 3rem;
  text-align: justify;

  h1 {
    color: ${({ theme }) => theme.color.black};
    font-size: ${({ theme }) => theme.fontSize['5xl']};
    font-weight: ${({ theme }) => theme.fontWeight['bold']};
    line-height: ${({ theme }) => theme.lineHeight['none']};
    margin-bottom: 1.25rem;
  }

  p {
    color: ${({ theme }) => theme.color.black};
    font-size: ${({ theme }) => theme.fontSize.sm};
    padding: 0.4rem 0;
  }

  a {
    color: ${({ theme }) => theme.color.vividBlue};
    position: relative;
    &::after {
      content: '';
      position: absolute;
      transition: width 0.2s ease-in-out;
      width: 0;
    }
    &:hover {
      &::after {
        height: 3px;
        background-color: ${({ theme }) => theme.color.vividBlue};
        opacity: 0.7;
        bottom: -4px;
        left: 0;
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    text-align: center;
  }
`

export const ImageContainer = styled.div`
  width: 65%;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  opacity: 0;
  animation: fadeInLow 0.6s 0.3s cubic-bezier(0.19, 1, 0.22, 1) forwards;

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 300px;
  }

  @keyframes fadeInLow {
    100% {
      opacity: ${({ opacity }) => (opacity ? opacity : 1)};
    }
  }
`

export const DownloadImages = styled.div`
  margin: ${({ theme }) => theme.remToPx(40)} 0;
`
